import { useMedicationConfigOverride } from '../contexts/DrugProgramProvider';
import { getFragment } from '../graphql/client/helpers/get-fragment';
import type { ProviderOffersInfoFragment } from '../graphql/generated/graphql';
import { processProviderToPharmacyInfo } from '../util';

import type { PrescriptionOffer } from './use-prescription-offers';

export const usePharmacyName = (
    provider?:
        | PrescriptionOffer['provider']
        | ProviderOffersInfoFragment['provider']
) => {
    const configOverride = useMedicationConfigOverride();

    const pharmacy = getFragment(provider);
    const pharmacyInfo = pharmacy
        ? processProviderToPharmacyInfo(pharmacy, configOverride)
        : null;

    return pharmacyInfo?.name;
};
